<template>
  <Transition name="fade">
    <div
      v-if="isFlood"
      class="flood-modal"
    >
      <div class="popup">
        <div class="body">
          <i class="fas fa-times-circle flood-icon" />
          <div class="title">
            {{ $t('ui.flood_detected') }}
          </div>
          <div class="msg">
            {{ floodMessage }}
          </div>
          <div
            v-show="floodNextRetry"
            class="time"
          >
            {{ floodNextRetry }} {{ $t('crm.segments.time_ranges.seconds') }}...
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import eventBus from '@/setup/eventBus';
import type { FloodErrorResponse } from '@/types/core';

const isFlood = ref(false);
const floodMessage = ref('');
const floodNextRetry = ref(0);

let floodRetryInterval: NodeJS.Timeout;

eventBus.$on('flood-warning', (data: FloodErrorResponse) => {
  clearInterval(floodRetryInterval as any);
  isFlood.value = true;
  floodNextRetry.value = data.payload.seconds_to_wait_before_next_retry;
  floodMessage.value = data.message;
  floodRetryInterval = setInterval(() => {
    floodNextRetry.value -= 1;
    if (floodNextRetry.value <= 0) {
      isFlood.value = false;
      clearInterval(floodRetryInterval);
    }
  }, 1000);
});
</script>
<style lang="scss" scoped>
.flood-modal {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.3);

  &.fade-enter-active, &.fade-leave-active{
    transition: all .4s;
    .wrapper{
      transition: all .4s;
    }
  }
  &.fade-enter, &.fade-leave-to{
    opacity: 0;
    .wrapper{
      transform: translateY(20px);
    }
  }

  .popup {
    position: absolute;
    z-index: 999999;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    border-radius: 8px;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    width: 360px;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.09);

    .body {
      padding: 40px;

      .flood-icon {
        font-size: 64px;
        color: var(--text-negative);
      }

      .title {
        font-size: 20px;
        font-weight: 600;
        margin-top: 16px;
      }

      .msg {
        font-size: 14px;
        margin-top: 8px;
      }

      .time {
        font-size: 16px;
        font-weight: 600;
        margin-top: 16px;
        color: var(--text-primary);
      }
    }
  }

  .wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0.5;
    background-color: #303634;
    z-index: 901;
    width: 100% !important;
  }
}
</style>
